/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState,useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login, forgot_password, UserDetails } from '../../redux/actions/authActions';
import { TextField, Button, CircularProgress, Alert, Container, Box, Typography } from '@mui/material';
import Loading from '../Loading';
import { Navigate, useNavigate,Link } from 'react-router-dom';
import './Styles.scss';

const ForgotPasswordComp = () => {
  const [formData, setFormData] =useState({ email: ''});
  const [errors, setErrors] = useState({ email: ''});
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error,message,user,isLoggedIn,auth_token } = useSelector((state) => state.auth);
  const handleChange = (e) => {
    const {name,value}= e.target;
    setFormData(formData=>({...formData,[name]:value}));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    let valid = true;

    if (!formData.email) {
      setErrors((prevErrors) => ({ ...prevErrors, email: 'Email is required' }));
      valid = false;
    }

    if (valid) {
      // Handle form submission
      // console.log('Form submitted', formData);
      dispatch(forgot_password(formData.email)); 
     
    }    
  };  
  useEffect(()=>{
      if(auth_token){
        dispatch(UserDetails());
        navigate("/home"); 
      }
  },[auth_token])
  return (
      
    <Box>
       {/*  {
            loading?<Loading />:""
        } */}
        <Box
        className="loginMain"
       
        >
          <Box className="loginBoxInn">
            <Typography component="h1" variant="h4" mb={2}>
                Forgot Password 
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate gap={'15px'} display={'flex'} flexDirection={'column'} width={'100%'}>
                <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={formData.email}
                onChange={(e) => {
                    handleChange(e);
                }}
                error={!!errors.email}
                helperText={errors.email}
                />
                <Box className="btmButton">                  
                  <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  >
                  {loading ?  <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Submit'}
                  </Button>
                </Box>
                <Box textAlign={"right"} style={{ color: '#8BAF91' }}>
                  <Link to="/login" style={{ color: '#8BAF91' }} variant="body2">
                      Login
                  </Link>
                </Box>
            </Box>
            </Box>
        </Box>
    </Box>
  );
};

export default ForgotPasswordComp;
